if (window.location.href.indexOf("/cart") > -1) {
  const elementToObserve = document.querySelector(".js-contents-footer");
  const goalValue = document.querySelector('.cart-alert').getAttribute("metafield-goal-value");
  let cartSubtotalValue = document.querySelector(".js-contents-footer .totals__subtotal-value").getAttribute('value');
  let goalRemainingValue = goalValue - cartSubtotalValue;

  goalRemainingValue = Number(goalRemainingValue).toFixed(2);

  if(goalRemainingValue > 0) {
    document.querySelector('.cart-alert__remaining-message').classList.remove('hidden');
    document.querySelector('.cart-alert__qualify-message').classList.add('hidden');
    document.querySelector('.cart-alert__goal-calc').innerHTML = `$${goalRemainingValue}`;
    document.querySelector('.cart-alert__progress-bar').setAttribute('value', goalValue - goalRemainingValue);
  } else {
    document.querySelector('.cart-alert__remaining-message').classList.add('hidden');
    document.querySelector('.cart-alert__qualify-message').classList.remove('hidden');
    document.querySelector('.cart-alert__progress-bar').setAttribute('value', goalValue);
  }

  const observer = new MutationObserver(function() {
    cartSubtotalValue = document.querySelector(".js-contents-footer .totals__subtotal-value").getAttribute('value');
    goalRemainingValue = goalValue - cartSubtotalValue;

    if(goalRemainingValue > 0) {
      document.querySelector('.cart-alert__remaining-message').classList.remove('hidden');
      document.querySelector('.cart-alert__qualify-message').classList.add('hidden');
      document.querySelector('.cart-alert__goal-calc').innerHTML = `$${goalRemainingValue.toFixed(2)}`;
      document.querySelector('.cart-alert__progress-bar').setAttribute('value', goalValue - goalRemainingValue.toFixed(2));
    } else {
      document.querySelector('.cart-alert__remaining-message').classList.add('hidden');
      document.querySelector('.cart-alert__qualify-message').classList.remove('hidden');
      document.querySelector('.cart-alert__progress-bar').setAttribute('value', goalValue); 
    }
  });

  observer.observe(elementToObserve, {childList: true});
} else {
  const goalValue = document.querySelector('.cart-alert').getAttribute("metafield-goal-value");
  let cartSubtotalValue = document.querySelector(".cart-drawer__footer .totals__subtotal-value").getAttribute('value');
  let goalRemainingValue = goalValue - cartSubtotalValue;

  goalRemainingValue = Number(goalRemainingValue).toFixed(2);

  if(goalRemainingValue > 0) {
    document.querySelector('.cart-alert__remaining-message').classList.remove('hidden');
    document.querySelector('.cart-alert__qualify-message').classList.add('hidden');
    document.querySelector('.cart-alert__goal-calc').innerHTML = `$${goalRemainingValue}`;
    document.querySelector('.cart-alert__progress-bar').setAttribute('value', goalValue - goalRemainingValue);
    document.querySelector('.cart-drawer__estimated-shipping').innerHTML = '$8'
  } else {
    document.querySelector('.cart-alert__remaining-message').classList.add('hidden');
    document.querySelector('.cart-alert__qualify-message').classList.remove('hidden');
    document.querySelector('.cart-alert__progress-bar').setAttribute('value', goalValue);
    document.querySelector('.cart-drawer__estimated-shipping').innerHTML = '$0'
  }
}